import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProductCrossReferenceService } from './core/product-cross-reference.service';
import { WindowRef } from '@spartacus/core';
import { BehaviorSubject, take } from 'rxjs';
import { Location } from '@angular/common';
import { DEVICE_SIZE } from '../../../core/models/others.model';
import { ICON_TYPE } from '@spartacus/storefront';
import { CustomValidatorService } from '../../../components/form-elements/custom-validator.service';
import { ProductReferencesStatusRequest } from './core/product-cross-reference.model';
import { initialStatus } from '../../../core/models/request-status.model';
import { Alert, ALERT_TYPE } from '../../../components/alert/alert.model';

@Component({
  selector: 'product-cross-reference',
  templateUrl: './product-cross-reference.component.html',
  styleUrl: './product-cross-reference.component.scss',
  standalone: false,
})
export class ProductCrossReferenceComponent implements OnInit {
  form: FormGroup = this.fb.group({
    searchType: ['STARTS_WITH', []],
    search: ['', [this.customValidatorService.noLeadingBlankSpaces(3)]],
  });

  DEVICE_SIZE = DEVICE_SIZE;
  iconTypes = ICON_TYPE;
  isSearched = new BehaviorSubject(false);
  req$ = new BehaviorSubject<ProductReferencesStatusRequest>(initialStatus);

  alertMessage: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(
    protected fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private productCRService: ProductCrossReferenceService,
    private customValidatorService: CustomValidatorService,
    private winRef: WindowRef,
  ) {}

  ngOnInit(): void {
    this.handleParams();
  }

  handleParams() {
    this.route.queryParamMap.subscribe(params => {
      const productCode = params.get('code');

      if (productCode) {
        this.form.patchValue({
          searchType: 'IS_EXACTLY',
          search: productCode,
        });
        this.submit();
        this.isSearched.next(true);
      }
    });
  }

  submit() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const code = this.form.get('search')?.value;
      const searchType = this.form.get('searchType')?.value;

      this.productCRService
        .getProductCrossReference(code, searchType)
        .pipe(take(1))
        .subscribe(data => {
          this.req$.next(data);
        });

      if (this.winRef.isBrowser()) {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('code', code);
        this.isSearched.next(true);

        this.location.replaceState(window.location.pathname, currentParams.toString());
      }
    }
  }
}
